import { render, staticRenderFns } from "./internalProject.vue?vue&type=template&id=4cb0dd9d&scoped=true&"
import script from "./internalProject.vue?vue&type=script&lang=ts&"
export * from "./internalProject.vue?vue&type=script&lang=ts&"
import style0 from "./internalProject.vue?vue&type=style&index=0&id=4cb0dd9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb0dd9d",
  null
  
)

export default component.exports